<template>
  <div>
    <div class="c-button c-button--icon">
      <label class="c-button__item c-button__item--primary">
        <input class="u-hidden"
               :disabled="searchAttributesLoading"
               @click="handleOpenModal"
        >
        <Icon name="iconPlus" class="imageAdd__icon" />
        {{ $t('messages.selectStores') }}
      </label>
    </div>
    <StoreCountFilterModal
      v-if="showStoreCountFilterModal"
      :target-services="targetServices"
      @close="handleCloseFilterModal"
      @submit="handleSubmit"
      @reset="handleReset"
    />
    <StoreModal
      v-if="showStoreModal"
      store-name="companiesMediaLibraries"
      @close-store-modal="handleClose"
      @back-filter-modal="handleBack()"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import StoreModal from '../StoreModal'
import StoreCountFilterModal from '../StoreCountFilterModal'
import Icon from '../Icon'

export default {
  name: 'CompaniesMediaLibrariesSelectStores',
  components: {
    Icon,
    StoreModal,
    StoreCountFilterModal,
  },
  props: {
    storeUuids: {
      type: Array,
      required: true,
    },
    targetServices: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['change-store-uuids'],
  data() {
    return {
      showStoreCountFilterModal: false,
      showStoreModal: false
    }
  },
  computed: {
    ...mapState({
      searchAttributesLoading : state => state.companiesSearchTagGroups.loading,
      brands: state => state.companiesSearchTagGroups.data.brands,
      franchisees: state => state.companiesSearchTagGroups.data.franchisees,
      areas: state => state.companiesSearchTagGroups.data.areas,
      userCompanies: state => state.companiesSearchTagGroups.data.user_companies,
      prefectures : state => state.companiesSearchTagGroups.data.prefectures,
      originalTagGroupA : state => state.companiesSearchTagGroups.data.original_tag_group_a,
      originalTagGroupB : state => state.companiesSearchTagGroups.data.original_tag_group_b,
      originalTagGroupC : state => state.companiesSearchTagGroups.data.original_tag_group_c,
      originalTagGroupD : state => state.companiesSearchTagGroups.data.original_tag_group_d,
      originalTagGroupE : state => state.companiesSearchTagGroups.data.original_tag_group_e,
      storeData:  state => state.companiesGmbSearchStores.data,
      searchStoreLoading:  state => state.companiesGmbSearchStores.loading,
    }),
    companyUuid() { return this.$route.params.company_uuid },
    readStoreParams() {
      const params = {
        companyUuid: this.companyUuid,
        formValues: {},
        excludeBusinessTypes: [],
      }
      if (this.targetServices.length >= 2) {
        params.onlyConnectedGmb = false
        params.onlyConnectedYahooPlace = false
      } else {
        params.onlyConnectedGmb = this.targetServices.includes('google_map')
        params.onlyConnectedYahooPlace = this.targetServices.includes('yahoo_map')
      }
      return params
    },
  },
  async created() {
    this.readStores(this.readStoreParams)
    await this.readSearchTagGroups()
    this.setGmbSearchAttributesFormStoreValues(this.formInitialValues())
  },
  methods: {
    ...mapActions({
      readStores: 'companiesGmbSearchStores/readStores',
      readSearchTagGroups: 'companiesSearchTagGroups/readSearchTagGroups'
    }),
    ...mapMutations({
      setFormValues: 'companiesMediaLibraries/setFormValues',
      setGmbSearchAttributesFormStoreValues: 'companiesSearchTagGroups/setFormValues',
    }),
    handleCloseFilterModal() {
      this.setFormValues({ stores: [...this.storeUuids] })
      this.showStoreCountFilterModal = false
    },
    handleOpenModal() {
      if (this.storeUuids.length !== 0) {
        this.showStoreModal = true
      } else {
        this.readStores(this.readStoreParams)
        this.showStoreCountFilterModal = true
      }
    },
    handleSubmit() {
      this.setFormValues({ stores: this.storeData.map(data => data.attributes.uuid) })
      this.showStoreCountFilterModal = false
      this.showStoreModal = true
    },
    handleReset() {
      this.showStoreCountFilterModal = false
    },
    handleBack() {
      this.showStoreModal = false
      this.showStoreCountFilterModal = true
    },
    handleClose(storeUuids) {
      this.showStoreModal = false
      this.$emit('change-store-uuids', storeUuids)
    },
    formInitialValues() {
      return {
        brands: this.brands.tags.map(v => v.id),
        franchisees: this.franchisees.tags.map(v => v.id),
        areas: this.areas.tags.map(v => v.id),
        user_companies: this.userCompanies.tags.map(v => v.id),
        prefectures: this.prefectures.tags.map(v => v.id),
        original_tag_group_a: this.originalTagGroupA?.tags.map(v => v.id),
        original_tag_group_b: this.originalTagGroupB?.tags.map(v => v.id),
        original_tag_group_c: this.originalTagGroupC?.tags.map(v => v.id),
        original_tag_group_d: this.originalTagGroupD?.tags.map(v => v.id),
        original_tag_group_e: this.originalTagGroupE?.tags.map(v => v.id)
      }
    },
  },

}
</script>

<style lang="scss" scoped>
.imageAdd__icon {
  width: 16px;
  margin-right: 8px;
}
.c-button {
  margin-top: 0 !important;
}

</style>
